module.exports = __webpack_public_path__ + "img/motul-logo.2a43981a.svg";